const defaultNegative = () => null;
/* *
 * util for rendering jsx if conditional is met
 * */
export default function renderIf(conditional, affirmative, negative = defaultNegative) {
  return conditional ? affirmative() : negative();
}



// WEBPACK FOOTER //
// ./src/util/renderIf.js